<template src='./changeApplicationModal.pug' lang='pug'></template>

<script>
import Modal from '../modal/Modal'
import ButtonApplication from '../../buttons/buttonApplication/ButtonApplication'
import idioma from '../../../../build/language/index'
import aplicacaoEnum from '../../../enum/aplicacaoEnum'

export default {
  name: 'ChangeApplicationModal',

  components: {
    Modal,
    ButtonApplication
  },

  data () {
    return {
      equalsCartoesImg: require('../../../assets/icones_app/cartao_azul.svg'),
      equalsBankingImg: require('../../../assets/icones_app/banco_branco.svg'),
      equalsExtratoImg: require('../../../assets/icones_app/extrato_azul.svg'),
      equalsCobrancaImg: require('../../../assets/icones_app/cobranca_zaul.svg'),
      equalsBandeirasImg: require('../../../assets/icones_app/bandeira_azul.svg'),
      aplicacoes: []
    }
  },

  computed: {
    applicationList () {
      return this.$store.getters.clientApps
    },

    openAppChangeModal () {
      return this.$store.getters.openAppChangeModal
    },

    modalWidthByAppList (index) {
      let style = ''
      switch (this.aplicacoes.length) {
        case 2:
          style = 'col-xs-6'
          break
        case 3:
          style = 'col-xs-4'
          break
        case 4:
          style = 'col-xs-3'
          break
        case 5:
          style = 'col-xs-2'
          break
        default:
          style = 'col-xs-6'
          break
      }
      return style
    }
  },

  watch: {
    openAppChangeModal () {
      if (this.$store.getters.isLoggedIn) {
        this.loadAplications()
      }
    }
  },

  methods: {
    loadAplications () {
      this.aplicacoes = []
      this.applicationList.forEach(appId => {
        if (appId !== aplicacaoEnum.BANDEIRAS && appId !== aplicacaoEnum.APLICATIVO) {
          this.aplicacoes.push(this.mountAppObject(appId))
        }
      })
      this.aplicacoes.sort(function (x, y) {
        // true values first
        return (x.active === y.active) ? 0 : x.active ? -1 : 1
      })
      this.showModal()
    },

    showModal () {
      $('#modal-troca-app').modal({
        backdrop: 'static',
        keyboard: false
      })

      setTimeout(() => {
        this.aplicacoes.forEach(app => {
          this.normilizeMArgin(app.id)
        })
      }, 100)
    },

    closeModal () {
      $('#modal-troca-app').modal('hide')
    },

    abrirEqualsCartoes () {
      $('#modal-troca-app').modal('hide')
    },

    calcWidth (app) {
      let base = ''
      switch (this.aplicacoes.length) {
        case 2:
          base = 'col-xs-6'
          break
        case 3:
          base = 'col-xs-4'
          break
        case 4:
          base = 'col-xs-3'
          break
        case 5:
          base = 'col-xs-2'
          app.id === 8 ? base += ' col-xs-offset-1' : ''
          break
      }
      return base
    },

    normilizeMArgin (id) {
      let image = document.getElementsByName('rounded-div-image-' + id)
      if (image && image.length > 0) {
        image[0].style.margin = '0 auto'
      }
    },

    mountAppObject (id) {
      let self = this
      let app = {
        id: id,
        click: function () {
          return self.trocaAplicacao(id)
        }
      }
      switch (id) {
        case 1:
          app.descricao = this.$t('trocaApp.aplicacoes.cartoes')
          app.imagem = this.equalsCartoesImg
          app.active = false
          break
        case 5:
          app.descricao = this.$t('trocaApp.aplicacoes.extrato')
          app.imagem = this.equalsExtratoImg
          app.active = false
          break
        case 6:
          app.descricao = this.$t('trocaApp.aplicacoes.cobranca')
          app.imagem = this.equalsCobrancaImg
          app.active = false
          break
        case 8:
          app.descricao = this.$t('trocaApp.aplicacoes.banking')
          app.imagem = this.equalsBankingImg
          app.active = true
          app.click = this.closeModal
          break
      }
      return app
    },

    trocaAplicacao (idAplicacao) {
      let app = {
        idAplicacao: idAplicacao,
        lang: idioma.getCookieByName('language')
      }
      this.$store.dispatch('trocaAplicacao', app)
        .then((response) => {
          window.open(response, '_self')
          this.closeModal()
        })
        .catch((error) => {
          this.$root.$refs.notification.error(error.message)
          this.closeModal()
        })
    },

    aplicacaoIndisponivel () {
      this.$root.$refs.notification.warning(this.$t('GENERAL'), this.$t('trocaApp.erro.aplicacaiIndisponivel'))
      this.closeModal()
    }
  }
}
</script>

<style lang='css'>
.pad-20 {
  padding: 20px;
}

#modal-troca-app .modal-lg {
  width: 62vw;
}
</style>



// WEBPACK FOOTER //
// ChangeApplicationModal.vue?8a1fa9ca